import React from 'react';
import { useEffect, useReducer, useState } from "react";

import { Carousel } from 'react-bootstrap';
import './Accreditation.css'; 
import Footer from '../../Footer';


function Accreditation() {

    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
      setIndex(selectedIndex);
    };

  return (
    <div className="hero-section">
      <Carousel activeIndex={index} onSelect={handleSelect}>
      <Carousel.Item>
          <img
            className="d-block w-100"
            src="../images/taille.png"
            alt="image3"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="../images/carou21.jpg"
            alt="image1"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="../images/taille_2.jpg"
            alt="image2"
          />
        </Carousel.Item>
    
      </Carousel>

  
            <div className="container-fluid"> 
                <div className="row">
                    <div className="col-sm-12 text-center">
                        <br />
                        <h1><u>ACCREDITATION</u></h1>
                        <p>Dans le cadre de notre appui à la démarche qualité, nos prestations et la qualification de nos inspecteurs, la Société « Professional Inspectors »a obtenu son accréditation en test hydraulique pour le transport par pipeline du gaz (A3) selon la norme ISO / CEI 17020. Ce processus est en évolution continue afin d'obtenir les dernières accréditations dans les différents domaines de l'inspection et essais techniques. Dans le même sens, la société est accréditée par le bureau international VERITAS dans le domaine des contrôles et inspection ultrasoniques et particulièrement des mesures d’épaisseur des navires.</p>
                    </div>
                </div>
          
        </div>
     

        <br />
        <div className="container">
            <table className="table table-sm table-bordered">
                <tbody>
                    <tr>
                        <td>Contrôle Non Destructif</td>
                        <td>Agrément de L'API N°SDV 090026B</td>
                    </tr>
                    <tr>
                        <td>Contrôle par Radiographie</td>
                        <td>Agrément de L'API N°SDV 090026B</td>
                    </tr>
                    <tr>
                        <td>Contrôle par Magnétoscopie</td>
                        <td>Agrément de L'API N°SDV 090026B</td>
                    </tr>
                    <tr>
                        <td>Contrôle par ressuage</td>
                        <td>Agrément de L'API N°SDV 090026B</td>
                    </tr>
                    <tr>
                        <td>Contrôle par Ultrason</td>
                        <td>Agrément de L'API N°SDV 090026B</td>
                    </tr>
                </tbody>
            </table>
        </div>


        <br />
        <div className="container">
            <table className="table table-sm table-bordered">
                <tbody>
                    <tr>
                        <td>A1</td>
                        <td> Epreuve Hydraulique Officielle des appareils à Vapeur</td>
                    </tr>
                    <tr>
                        <td>A2</td>
                        <td>Epreuve hydraulique officielle des appareils à pression de gaz</td>
                    </tr>
                    <tr>
                        <td>A3</td>
                        <td>Epreuve hydraulique officielle des ouvrages de transport de gaz combustibles par canalisation.</td>
                    </tr>
                    <tr>
                        <td>B1</td>
                        <td>Certification des installations de gaz dans les domaines industriels.</td>
                    </tr>
                    <tr>
                        <td>B2</td>
                        <td>Certification des installations électriques dans les domaines industriels.</td>
                    </tr>
                    <tr>
                        <td>B3</td>
                        <td>Certification des appareils de levage et des ascenseurs.</td>
                    </tr>
                    <tr>
                        <td>B4</td>
                        <td>Epreuve hydraulique officielle des ouvrages de transport d’hydrocarbures liquides par canalisation.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="slider">
	<div class="slide-track">
		<div class="slide">
			<img src="../images/Shell-logo.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/marino.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/TotalEnergies-Nouveau-Logo.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/steg.png" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/ecm.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/sncpa.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/omv.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/meri.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/socomenin.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/etap.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/boucahmeoui.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/colas-rail.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/daewooe&c.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/nesteoil.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/metec.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/petrofac.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/pionner.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/sarost.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/serpet.jpg" height="100" width="250" alt="" />
		</div>
		<div class="slide">
			<img src="../images/ciments-de-bizete.jpg" height="100" width="250" alt="" />
		</div>
		
	</div>
    </div>


    <Footer/>
</div>

  );
}

export default Accreditation;
